import { NAME_RUSSIAN_KEY } from '@esentai/core/features/locations/consts/keys';
import { annotations } from '@esentai/core/features/locations/serializer';
import { ascending } from '@esentai/core/query-dsl';
import { sort, string } from '@esentai/core/serializers/params';

import { createPageSerializer, getLinkCreator } from '@/serializers';

import { ROUTE_PATH } from './consts';

const serializer = createPageSerializer({
  ...annotations,

  sort: sort({
    defaultValue: ascending(NAME_RUSSIAN_KEY),
  }),
  include: string({
    defaultValue: ['beacons'],
  }),
});

export const createLink = getLinkCreator(ROUTE_PATH, serializer);

export default serializer;
